export default "__VITE_ASSET__DKCxqlys__"